module.exports = __webpack_public_path__ + "public/img/ico-email-active.29cb0646.svg";